import ReportTabs from '../filters/ReportTabs';
import FulfillmentTabs from '../filters/FulfillmentTabs';
import OperationTabs from '../filters/OperationTabs';
import FilterToolbar from '@/components/filters/FilterToolbar';
import { useAuthStore } from '../../stores/auth-store';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import StoreSwitcher from './StoreSwitcher';

export default function HeaderCustom({ 
  selectedStatus, 
  selectedSubStatus,
  onStatusSelect,
  onSubStatusSelect,
  showFulfillmentTabs = false,
  showOperationTabs = false,
  showReportTabs = false,
  isDashboard = false,
  showTakeInButton = false,
  isTakeInActive = false,
  onTakeInClick,
  onSubmitNowClick,
  showShipButton = false,
  isShipActive = false,
  onShipClick,
  onShipNowClick,
  showOutboundSubmit = false,
  onOutboundSubmitClick,
  showShipmentSubmit = false,
  onShipmentSubmitClick,
  // Destination Warehouse → In-Warehouse
  showToCenterButton = false,
  isToCenterActive = false,
  onToCenterClick,
  showToCenterSubmit = false,
  onToCenterSubmitClick
}: { 
  selectedStatus?: string;
  selectedSubStatus?: string;
  onStatusSelect?: (status: string) => void;
  onSubStatusSelect?: (subStatus: string) => void;
  showFulfillmentTabs?: boolean;
  showOperationTabs?: boolean;
  showReportTabs?: boolean;
  isDashboard?: boolean;
  showTakeInButton?: boolean;
  isTakeInActive?: boolean;
  onTakeInClick?: () => void;
  onSubmitNowClick?: () => void;
  showShipButton?: boolean;
  isShipActive?: boolean;
  onShipClick?: () => void;
  onShipNowClick?: () => void;
  showOutboundSubmit?: boolean;
  onOutboundSubmitClick?: () => void;
  showShipmentSubmit?: boolean;
  onShipmentSubmitClick?: () => void;
  showToCenterButton?: boolean;
  isToCenterActive?: boolean;
  onToCenterClick?: () => void;
  showToCenterSubmit?: boolean;
  onToCenterSubmitClick?: () => void;
}) {
  const { logout } = useAuthStore();
  const navigate = useNavigate();
  // const { pathname } = useLocation();
  
  // Check if we're on the settings page
  // const isSettingsPage = pathname === '/settings';

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/auth/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Still navigate to login even if logout API fails
      navigate('/auth/login');
    }
  };

  return (
    <div className="pb-6">
      <div className="flex justify-between items-center mb-6 p-4 bg-[#9C9B9B]">
        
        {/* Store Switcher - Left Side */}
        <div className="flex gap-7 px-7">
          <StoreSwitcher />
        </div>

        {/* Logout Button - Far Right End */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span>Log Out</span>
        </button>
      </div>

      {/* Status Tabs - Hidden on Dashboard */}
      {!isDashboard && (
        <>
          {showFulfillmentTabs ? (
            <FulfillmentTabs 
              selected={selectedStatus} 
              onSelect={onStatusSelect} 
              onSubStatusSelect={onSubStatusSelect} 
            />
          ) : showOperationTabs ? (
            <OperationTabs 
              selected={selectedStatus} 
              selectedSubStatus={selectedSubStatus} 
              onSelect={onStatusSelect} 
              onSubStatusSelect={onSubStatusSelect} 
            />
          ) : showReportTabs ? (
            <ReportTabs 
              selected={selectedStatus} 
              selectedSubStatus={selectedSubStatus}
              onSelect={onStatusSelect} 
              onSubStatusSelect={onSubStatusSelect}
            />
          ) : null}
        </>
      )}
      
      {/* Filter Toolbar */}
      <div className="mb-4 w-full">
        <FilterToolbar 
          isDashboard={isDashboard} 
          showTakeInButton={showTakeInButton}
          isTakeInActive={isTakeInActive}
          onTakeInClick={onTakeInClick}
          onSubmitNowClick={onSubmitNowClick}
          showShipButton={showShipButton}
          isShipActive={isShipActive}
          onShipClick={onShipClick}
          onShipNowClick={onShipNowClick}
          showOutboundSubmit={showOutboundSubmit}
          onOutboundSubmitClick={onOutboundSubmitClick}
          showShipmentSubmit={showShipmentSubmit}
          onShipmentSubmitClick={onShipmentSubmitClick}
          // Destination Warehouse → In-Warehouse props
          showToCenterButton={showToCenterButton}
          isToCenterActive={isToCenterActive}
          onToCenterClick={onToCenterClick}
          showToCenterSubmit={showToCenterSubmit}
          onToCenterSubmitClick={onToCenterSubmitClick}
        />
      </div>
    </div>
  );
} 